<template>
  <div>
    <input
      id="uploadmyfile"
      type="file"
      ref="file"
      hidden
      class=""
      accept=".mp3,.mp4,.AAC,.wav"
      multiple="multiple"
      v-on:change="handleFileUpload"
    />
    <div
      v-show="!fileSelectedFlag"
      class="p-4"
      style="
        text-align: center;
        border: 1px dashed #cad2dc;
        background: #eff7fb;
      "
      v-cloak
      @drop.prevent="dropFile"
      @dragover.prevent
    >
      <img
        class="mT25"
        src="@/assets/images/file-upload-logo.svg"
        alt
        height="60"
      />
      <p class="font-size-16 mT25">
        Drag and drop files here
        <a
          href="#"
          v-on:click="$el.querySelector('#uploadmyfile').click()"
          style="text-decoration: underline !important"
          >click to browse</a
        >
        your computer. Acceptable file formats are MP3 MP4 AAC or WAV format.
        The individual file size should not exceed 15MB.
      </p>
    </div>
    <div v-show="fileSelectedFlag" class="p-4" style="text-align: center">
      <p class="font-size-16 mb-5">
        {{ `Your file ${fileName} is ready to upload` }}
      </p>
    </div>
    <div class="upload-btn">
      <b-button
        class="mt-3 float-right"
        variant="primary"
        v-if="uploadingfile"
        :disabled="uploadingfile"
        >Upload...</b-button
      >
      <b-button
        @click="uploadFile()"
        class="mt-3 float-right"
        variant="primary"
        :disabled="fileName === ''"
        v-else
        >Upload</b-button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    topbarControls: {
      type: Object,
      required: false,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true,
    },
    closeModal: {
      type: Function,
      required: false,
    },
  },
  data() {
    return {
      fileSelectedFlag: false,
      fileName: "",
      searchText: "",
      showButton: false,
      showSearch: false,
      showRevertButton: false,
      selectedComments: null,
      selectedMessage: null,
      buttonPosition: { top: "0px", left: "0px" },
      value: this.item_value,
      d_check: this.selectedItem
        ? this.selectedItem[this.item.displayOn]
        : false,
      showComments: false,
      uploadingfile: false,
    };
  },
  computed: {
    getFileNames() {
      let data = {};
      if (this.topbarControls?.listItems) {
        this.topbarControls.listItems.forEach((rt) => {
          data[rt.title] = rt.id;
        });
      }
      return data;
    },
  },
  methods: {
    async getPresignedUrl(fileName) {
      try {
        const response = await axios.post(
          "https://ngcci3rslg.execute-api.eu-west-1.amazonaws.com/Prod/v1/get-upload-url",
          { file_name: fileName },
          {
            headers: {
              "x-api-key": "PLPWufjyeH7b5tIjOuh988fxid2I8tj71i0P4o64",
              "Content-Type": "application/json",
            },
          }
        );
        return response.data.presign_url;
      } catch (error) {
        console.error("Error getting presigned URL:", error);
        throw new Error("Failed to get upload URL");
      }
    },
    getIsoDateString() {
      const date = new Date();

      // Pad single digits with leading zeros
      const pad = (number) => number.toString().padStart(2, "0");

      const year = date.getUTCFullYear();
      const month = pad(date.getUTCMonth() + 1); // getUTCMonth() returns months from 0-11
      const day = pad(date.getUTCDate());
      const hours = pad(date.getUTCHours());
      const minutes = pad(date.getUTCMinutes());
      const seconds = pad(date.getUTCSeconds());

      // Combine components in the ISO 8601 format
      return `${year}${month}${day}T${hours}${minutes}${seconds}Z`;
    },
    constructAwsCredentialString(accessKeyId) {
      const date = new Date();
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are 0-based in JavaScript, add 1 to get 1-12
      const day = String(date.getUTCDate()).padStart(2, "0");
      const dateString = `${year}${month}${day}`;

      const region = "eu-west-1"; // Static region
      const service = "s3"; // Static service
      const awsRequest = `${accessKeyId}/${dateString}/${region}/${service}/aws4_request`;

      // URL-encode the generated string
      return encodeURIComponent(awsRequest);
    },
    getUrlParameter(url, name) {
      // Correctly escape special characters in 'name'
      name = name.replace(/[[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    extractBaseUrl(url) {
      // Split the URL by '?' to separate the base URL from the query parameters
      const [baseUrl] = url.split("?");
      return baseUrl;
    },
    async uploadFileToS3(presignedUrl) {
      var fileInput = document.getElementById("uploadmyfile");

      const config = {
        method: "PUT", // Use POST for form data
        url: presignedUrl, // Use the base URL without query parameters
        headers: {
          processData: false,
          "Content-Type": "application/octet-stream",
        },
        data: fileInput.files[0],
      };
      try {
        // Perform the upload
        const response = await axios(config);
        console.log("Upload successful", response.data);
      } catch (error) {
        console.error("Error uploading file to S3:", error);
        throw new Error("Failed to upload file to S3");
      }
    },
    async extractTextFromUploadedFile(fileName) {
      let data = JSON.stringify({
        file_name: `${fileName}`,
      });
      try {
        const response = await axios.post(
          "https://ngcci3rslg.execute-api.eu-west-1.amazonaws.com/Prod/v1/extract-text",
          data,
          {
            headers: {
              "x-api-key": "PLPWufjyeH7b5tIjOuh988fxid2I8tj71i0P4o64",
              "Content-Type": "application/json",
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error("Error extracting text:", error);
        throw new Error("Failed to extract text");
      }
    },
    async uploadFile() {
      this.uploadingfile = true;
      try {
        const files = this.$refs.file.files;
        if (files.length === 1) {
          this.fileName = files[0].name;
          this.fileSelectedFlag = true;
          const presignedUrl = await this.getPresignedUrl(this.fileName);
          if (presignedUrl) {
            await this.uploadFileToS3(presignedUrl, files[0]);
            // let { status } = await this.extractTextFromUploadedFile(
            //   this.fileName
            // );
            this.$emit("saveandclose", {
              title: this.fileName,
              presignedUrl: presignedUrl,
              chat: [],
              status: "IN_PROGRESS",
            });
          }
        } else {
          this.fileSelectedFlag = false;
        }
      } catch (error) {
        console.error("Error handling file upload:", error);
        // Handle errors
      }
      this.uploadingfile = false;
    },
    async handleFileUpload() {
      try {
        const files = this.$refs.file.files;
        if (files.length === 1) {
          if (this.getFileNames[files[0].name]) {
            this.$message.error("File already exists !!!");
          } else {
            this.fileName = files[0].name;
            this.fileSelectedFlag = true;
          }
        } else {
          this.fileSelectedFlag = false;
        }
      } catch (error) {
        console.error("Error handling file upload:", error);
        // Handle errors
      }
    },

    dropFile(file) {
      console.log("dropfile", file);
    },

    // Your other methods...
  },
};
</script>

<style scoped>
.ck-button__label {
  font-family: "Montserrat";
}
input[type="date"]::-webkit-calendar-picker-indicator {
  color: rgba(0, 0, 0, 0);
  opacity: 1;
  display: block;
  width: 20px;
  height: 20px;
  border-width: thin;
}
.mT25 {
  margin-top: 25px;
}
.upload-btn {
  width: 100%;
  height: 60px;
  display: flex;
}
.upload-btn button {
  margin: auto;
}
</style>
